var exports = {
  "kL": "PushSettings.module__container___N3hjb2",
  "Qq": "PushSettings.module__text___N3hjb2",
  "DD": "PushSettings.module__title___N3hjb2",
  "h_": "PushSettings.module__description___N3hjb2",
  "GL": "PushSettings.module__comboboxWrap___N3hjb2",
  "EA": "PushSettings.module__combobox___N3hjb2",
};

module.exports = exports;
